import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../hooks/useDataFormatterHook";
import Crud from "../common/Crud";

/**
 * TABLE LEAGUEREGIONS
 */
function Profiles() {
  const { values: books } = useDataFormatterHook({
    value: "idBook",
    text: "description",
    path: "/Player/GetBooks",
  });

  return (
    <Crud
      title="Profiles"
      navigateUrl={({ idProfile }) => `/profile/${idProfile}`}
      getUrl={({ userId }) =>
        `/Profile/PlayerProfile_GetListWithInfo?idUser=${userId}`
      }
      // INSERT
      insertUrl={() => "/Profile/PlayerProfile_Insert"}
      insertParams={({ userId }, { profileName, idBook }) => ({
        Name: profileName,
        IdBook: Number(idBook),
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={({ userId }, id) =>
        `/Profile/PlayerProfile_Delete?idProfile=${id}&idUser=${userId}`
      }
      deleteResultMessages={{
        1: "Cannot delete the defined default profile",
        2: "Cannot delete a profile with players",
        3: "Cannot delete a profile with active wagers associated",
        4: "Cannot delete a profile with past wagers associated",
        5: "Cannot delete a profile with open wagers associated",
      }}
    >
      <TableHeaderColumn
        dataField="idProfile"
        hidden
        hiddenOnInsert
        autoValue
        isKey={true}
      >
        Profile ID
      </TableHeaderColumn>
      <TableHeaderColumn
        filter={{ type: "TextFilter", delay: 1000 }}
        dataField="profileName"
      >
        Name
      </TableHeaderColumn>
      <TableHeaderColumn
        hidden
        dataField="idBook"
        editable={{
          type: "select",
          options: {
            values: [
              {
                text: "ALL",
                value: 0,
              },
              ...books,
            ],
          },
        }}
      >
        Books
      </TableHeaderColumn>
    </Crud>
  );
}

export default Profiles;
